import React, { useState } from "react";
import HTMLReactParser from "html-react-parser";
import { useParams } from "react-router-dom";
import millify from "millify";
import { Col, Row, Typography, Select } from "antd";
import {
  MoneyCollectOutlined,
  DollarCircleOutlined,
  FundOutlined,
  ExclamationCircleOutlined,
  StopOutlined,
  TrophyOutlined,
  CheckOutlined,
  NumberOutlined,
  ThunderboltOutlined,
} from "@ant-design/icons";
// import { getCryptoDetailsQuery } from "../services/cryptoApi";
import {
  useGetCryptoDetailsQuery,
  useGetCryptoHistoryQuery,
} from "../services/cryptoApi";
import Loader from "./Loader";
import LineChart from "./LineChart";

const { Title, Text } = Typography;
const { Option } = Select;

const CryptoDetails = () => {
  const { coinId } = useParams();
  const [timePeriod, setTimePeriod] = useState("7d");
  const { data, isFetching } = useGetCryptoDetailsQuery(coinId);
  const { data: coinHistory } = useGetCryptoHistoryQuery({
    coinId,
    timePeriod,
  });
  const cryptoDetails = data?.data?.coin;

  // console.log(coinHistory);
  // console.log(cryptoDetails);

  if (isFetching) return <Loader />;

  const time = ["3h", "24h", "7d", "30d", "1y", "3m", "3y", "5y"];
  const stats = [
    {
      title: "Price to USD",
      value: `$ ${cryptoDetails.price && millify(Number(cryptoDetails.price))}`,
      icon: <DollarCircleOutlined />,
      id: 1,
    },
    {
      title: "Rank",
      value: cryptoDetails.rank,
      icon: <NumberOutlined />,
      id: 2,
    },
    {
      title: "24h Volume",
      value: `$ ${
        cryptoDetails.volume && millify(Number(cryptoDetails.volume))
      }`,
      icon: <ThunderboltOutlined />,
      id: 3,
    },
    {
      title: "Market Cap",
      value: `$ ${
        cryptoDetails.marketCap && millify(Number(cryptoDetails.marketCap))
      }`,
      icon: <DollarCircleOutlined />,
      id: 4,
    },
    {
      title: "All-time-high(daily avg.)",
      value: `$ ${millify(Number(cryptoDetails.allTimeHigh.price))}`,
      icon: <TrophyOutlined />,
      id: 5,
    },
  ];

  const genericStats = [
    {
      title: "Number Of Markets",
      value: cryptoDetails.numberOfMarkets,
      icon: <FundOutlined />,
      id: 1,
    },
    {
      title: "Number Of Exchanges",
      value: cryptoDetails.numberOfExchanges,
      icon: <MoneyCollectOutlined />,
      id: 2,
    },
    {
      title: "Aprroved Supply",
      value: cryptoDetails.approvedSupply ? (
        <CheckOutlined />
      ) : (
        <StopOutlined />
      ),
      icon: <ExclamationCircleOutlined />,
      id: 3,
    },
    {
      title: "Total Supply",
      value: `$ ${millify(Number(cryptoDetails.totalSupply))}`,
      icon: <ExclamationCircleOutlined />,
      id: 4,
    },
    {
      title: "Circulating Supply",
      value: `$ ${millify(Number(cryptoDetails.circulatingSupply))}`,
      icon: <ExclamationCircleOutlined />,
      id: 5,
    },
  ];

  return (
    <Col className="coin-detail-container">
      <Col className="coin-heading-container">
        <Title level={2} className="coin-name">
          {cryptoDetails.name} ({cryptoDetails.symbol}) Price
        </Title>
        <p>
          {cryptoDetails.name} live price in US dollars. View value statistics,
          market cap and supply.
        </p>
      </Col>
      <Select
        defaultValue="7d"
        className="select-timeperiod"
        placeholder="Select Time Period"
        onChange={(value) => setTimePeriod(value)}
      >
        {time.map((date) => (
          <Option key={date}>{date}</Option>
        ))}
      </Select>

      {/* line chart */}
      <LineChart
        coinHistory={coinHistory}
        currentPrice={millify(Number(cryptoDetails.price))}
        coinName={cryptoDetails.name}
      />

      <Col className="stats-container">
        <Col className="coin-value-statistics">
          <Col className="coin-value-statistics-heading">
            <Title level={3} className="coin-details-heading">
              {cryptoDetails.name} Value Statistics
            </Title>
            <p>An Overview showing the stats of {cryptoDetails.name}</p>
          </Col>
          {stats.map(({ icon, title, value, id }) => (
            <Col className="coin-stats" key={id}>
              <Col className="coin-stats-name">
                <Text>{icon}</Text>
                <Text>{title}</Text>
              </Col>
              <Text className="stats">{value}</Text>
            </Col>
          ))}
        </Col>
        {/* new stats */}
        <Col className="other-stats-info">
          <Col className="coin-value-statistics-heading">
            <Title level={3} className="coin-details-heading">
              Other Statistics
            </Title>
            <p>An Overview showing the stats of all Cryptocurrency</p>
          </Col>
          {genericStats.map(({ icon, title, value, id }) => (
            <Col className="coin-stats" key={id}>
              <Col className="coin-stats-name">
                <Text>{icon}</Text>
                <Text>{title}</Text>
              </Col>
              <Text className="stats">{value}</Text>
            </Col>
          ))}
        </Col>
      </Col>

      <Col className="coin-desc-link">
        <Row className="coin-desc">
          <Title level={3} className="coin-details-heading">
            What is {cryptoDetails.name} ?
            <br />
            <Text style={{ fontSize: "18px" }}>
              {cryptoDetails.description}
            </Text>
          </Title>
        </Row>
        <Col className="coin-links">
          <Title level={3} className="coin-details-heading">
            {cryptoDetails.name}
          </Title>
          {cryptoDetails.links.map((link, i) => (
            <Row className="coin-link" key={i}>
              <Title level={5} className="link-name">
                {link.type}
              </Title>
              <a href={link.url} target="_blank" rel="noreferrer">
                {link.name}
              </a>
            </Row>
          ))}
        </Col>
      </Col>
    </Col>
  );
};

export default CryptoDetails;
